import { IUser, UserState } from "@/types/user";
import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<UserState, IUser> = {
  single: (state, single) => {
    state.single = new User(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new User(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new User();
    state.pagination = new Pagination();
  },
};

export default mutations;
